import { type ChangeEvent, useRef, useState } from 'react'

import ImportIcon from '@/assets/icons/icon-import.svg'
import { handleError } from '@/utils/error'
import { classNames } from '@/utils/helpers'

import { Button } from './button'

interface Props {
  accept: string
  handleUpload: (file: File) => Promise<void>
  className?: string
  testId?: string
}

export const ImportFile = ({
  accept,
  handleUpload,
  className,
  testId,
}: Props) => {
  const [isUploading, setIsUploading] = useState(false)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const onFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (!file) return

    setIsUploading(true)
    try {
      await handleUpload(file)
    } catch (error) {
      handleError(error, 'Something went wrong while uploading file')
    } finally {
      setIsUploading(false)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  return (
    <>
      <Button
        as="label"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        htmlFor="import-file"
        variant="ghost"
        className={classNames(
          'cursor-pointer text-text-default hover:text-primary-500',
          className,
        )}
        disabled={isUploading}
        testId={testId}
      >
        <ImportIcon className="mb-1 mr-1" />
        Import
      </Button>
      <input
        id="import-file"
        type="file"
        accept={accept}
        hidden
        onChange={onFileChange}
        ref={fileInputRef}
      />
    </>
  )
}
